import { useAuth } from 'src/hooks/useAuth';

import UsersView from 'src/sections/users';

export default function UsersPage() {
  const { permissions } = useAuth();

  const isDeptManager = permissions?.includes('DASHBOARD:DEPT_MANAGER');
  const title = isDeptManager ? 'agents' : 'users';

  return <UsersView title={title} />;
}
